// Cross-sells "Lägg till" på checkout (renderas under #lw-checkout-extras i Klarna
// Checkout). Egen modul — checkout.js är medvetet avstängd.
//
// - Enkla produkter: knappen har data-product-id.
// - Variabla produkter: en inline-<select> håller antalsvarianterna; varje option-value
//   är variationens ID. WC:s wc-ajax=add_to_cart accepterar ett variations-ID direkt som
//   product_id (det löser upp förälder + attribut), så vi postar bara valt ID.
//
// e.stopImmediatePropagation() hindrar mini-cartens egen add-handler
// (.product_type_simple.add_to_cart_button i mini-cart.js) från att trigga popupen.
// Efter add triggas update_checkout som KCO lyssnar på → order/totaler räknas om.
jQuery(function ($) {
    // Byt visat pris när antalsvarianten ändras.
    $(document).on('change', '.lw-checkout-cross-sell-variation', function () {
        const row = $(this).closest('.lw-checkout-cross-sell')
        const priceHtml = $(this).find('option:selected').data('price')
        if (priceHtml) row.find('.lw-cross-sell-price').html(priceHtml)
    })

    // Sektionen ligger utanför .woocommerce-checkout-review-order (KCO:s
    // kco_wc_after_order_review) och uppdateras alltså inte av WC:s update_order_review.
    // Hämta om den vid updated_checkout så en redan tillagd produkt försvinner ur listan
    // (annars kan den läggas till igen) och totaler/priser hålls i synk med varukorgen.
    function refreshCheckoutCrossSells() {
        const container = document.getElementById('lw-checkout-cross-sells')
        if (!container || !window.liGlobal?.ajaxUrl) return
        $.ajax({
            url: window.liGlobal.ajaxUrl,
            method: 'POST',
            data: { action: 'lw_checkout_cross_sells' },
            success: function (resp) {
                if (resp && resp.success) container.innerHTML = resp.data.html
            },
        })
    }
    $(document.body).on('updated_checkout', refreshCheckoutCrossSells)

    $(document).on('click', '.lw-checkout-cross-sell-add', function (e) {
        e.preventDefault()
        e.stopImmediatePropagation()

        const btn = $(this)
        if (btn.prop('disabled')) return

        // Variabel produkt → valt variations-ID från select, annars simple-produktens ID.
        const select = btn.closest('.lw-checkout-cross-sell').find('.lw-checkout-cross-sell-variation')
        const productId = select.length ? select.val() : btn.data('product-id')
        if (!productId) return

        const tpl = window.wc_add_to_cart_params?.wc_ajax_url || '/?wc-ajax=%%endpoint%%'
        const url = tpl.replace('%%endpoint%%', 'add_to_cart')

        const originalText = btn.text()
        btn.prop('disabled', true)
        if (window.liGlobal?.addingToCartText) btn.text(window.liGlobal.addingToCartText)

        $.ajax({
            url: url,
            method: 'POST',
            data: { product_id: productId, quantity: 1 },
            success: function () {
                $(document.body).trigger('update_checkout')
            },
            complete: function () {
                btn.prop('disabled', false)
                btn.text(originalText)
            },
        })
    })
})
